function getCount(){
  var time= 1504027352941;
  var curr = (new Date()).getTime(); //current time in millionseconds

  var plus = Math.ceil((curr - time)/(86400000/24));

  var count = 2267 + plus;
	//console.log(count);
  return count.toString();
}